import Vue from 'vue'

export const EventBus = new Vue();
export const EventBusType = {
    ChangeChatView: 'ChangeChatView',
    TOAST: 'TOAST',
    TOGGLE_STAFF_CHAT: 'TOGGLE_STAFF_CHAT',
    NOTIFICATION_GROUP: 'NOTIFICATION_GROUP',
    CONFIRM: 'CONFIRM',
    CONFIRM_DONE: 'CONFIRM_DONE',
    ON_USE_MAD_TEMPLATE: 'ON_USE_MAD_TEMPLATE',
    ON_SELECT_SUGGESTION: 'ON_SELECT_SUGGESTION'
};

Vue.prototype.$EventBus = EventBus;
Vue.prototype.$EventBusType = EventBusType;

export default EventBus
